/**
 * Validation rules used in validation.js
 */


const validationRules = (() => {
    let _matching = {};
    let lang = document.querySelector('html').getAttribute('lang');

    /**
     * Set rule-logic matching
     */
    const init = () => {
        _matching = {
            required: required,
            autocomplete: autocomplete,
            phone: phone,
            phoneOptional: phoneOptional,
            postalCode: postalCode,
            name: name,
            email: email,
            file: file,
            size: size,
            minLength: minLength
        };
    };

    /**
     * Return matching rule
     * @param rule
     */
    const returnValidationRule = (rule) => {
        //TODO: add some element check/ parsing
        rule = rule.trim();
        return _matching[rule];
    };

    /**
     * required field validation test. Sometimes it can be a boolean value
     *
     * @param {String|Boolean|Array} value
     * @returns {boolean}
     */
    const required = (value, type) => {
        if (type !== "checkbox" && type !== "file")
            value = value.replace(/\s+/g, '');

        if(type === "file")
            value = value.length

        // for radios value = input.name
        if(type === "radio") {
            const radios = document.getElementsByName(value);
            value = undefined
     
            Array.from(radios).forEach( (input, index) => {
                if(input.checked) {
                    value = input.getAttribute('name');
                }
            })
        }

        if (!value) {
            return {
                error: true,
                msg: lang === 'en-US' ? "The field is required" : "Pole wymagane"
            };
        }

        return {error: false};
    };

    const autocomplete = (value, type) => {
        if (!value) {
            return {
                error: true,
                msg: lang === 'en-US' ? "Select from the list" : "Wybierz z listy"
            };
        }

        return {error: false};
    };

    /**
     * input file size validation test.
     *
     * @returns {boolean}
     */

    const size = (values, type, sizes) => {
        const validSize = 2097152;

        if(!values) return {error: false}

        const count = values.length;
        let error = false;

        sizes.forEach(size => {
            if (size > validSize)
                error = true
        })

        return !error ?
            {error: false} :
            {
                error: true,
                msg: lang === 'en-US' ?
                  (count > 1 ? 'One of your files is too large' : 'File size too large') :
                  (count > 1 ? 'Jeden z Twoich plików ma za duży rozmiar' : 'Zbyt duży rozmiar pliku')
            }
    };

    /**
     * input image file validation test.
     *
     * @returns {boolean}
     */
    const file = (values) => {
        const validExt = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.oasis.opendocument.text",
            "application/rtf",
            "image/png",
            "image/jpg",
            "image/jpeg",
        ];

        if(!values) return {error: false}

        const count = values.length;
        let error = false;

        values.forEach(value => {
            if (!validExt.includes(value))
                error = true
        })

        return (!error) ?
            {error: false} :
            {
                error: true,
                msg: (lang === 'pl-PL') ?
                  (count > 1 ? 'Jeden z Twoich plików ma błędny format' : 'Błędny format pliku') :
                  (count > 1 ? 'One of your files has the wrong format' : 'Wrong file format')
            };
    };

    /**
     * Name/surname validation test
     *
     * @param {String} value
     * @returns {Boolean}
     */
    const name = (value) => {
        return (/^[a-zżźćńółęąś\s\-]+$/i.test(value)) ? {error: false} : {
            error: true,
            msg: lang === 'en-US' ? 'The field can only contain letters' : 'Pole może zawierać tylko litery'
        };
    };

    const minLength = (value) => {
        return value.length >= 10 ? {error: false} : {
            error: true,
            msg: lang === 'en-US' ? 'The field must contain at least 10 letters' : 'Pole musi zawierać przynajmniej 10 liter'
        };
    };

    const email = (value) => {
        let polishLetters = /[ąĄćĆęĘłŁńŃóÓśŚźŹżŻ]/;

        if (value.indexOf("@") > -1) {
            let name = value.split('@')[0];

            if (name.length > 64) {

                if(lang === 'en-US') {
                    return {
                        error: true,
                        msg: 'E-mail address is invalid'
                    };
                }


                if(lang === 'pl-PL') {
                    return {
                        error: true,
                        msg: 'Podany e-mail jest nieprawidłowy'
                    };
                }
            }
        }

        if (value.match(polishLetters) !== null) {

            if(lang === 'en-US') {
                return {
                    error: true,
                    msg: 'E-mail address is invalid'
                };
            }


            if(lang === 'pl-PL') {
                return {
                    error: true,
                    msg: 'Podany e-mail jest nieprawidłowy'
                };
            }
        }

        if (!value) {

            if(lang === 'en-US') {
                return {
                    error: true,
                    msg: 'E-mail address is invalid'
                };
            }


            if(lang === 'pl-PL') {
                return {
                    error: true,
                    msg: 'Podany e-mail jest nieprawidłowy'
                };
            }
        }

        if(lang === 'en-US') {
            return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? {error: false} : {
                error: true,
                msg: 'E-mail address is invalid'
            };
        }


        if(lang === 'pl-PL') {
            return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? {error: false} : {
                error: true,
                msg: 'Podany e-mail jest nieprawidłowy'
            };
        }

    };

    const phone = (value) => {
        if(lang === 'en-US') {
            return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(value) ? {error: false} : {
                error: true,
                msg: "E-mail address is invalid"
            };
        }

        if(lang === 'pl-PL') {
            
        }
    };

    const postalCode = (value) => {
        return /^\d{2}-\d{3}$/im.test(value) ? {error: false} : {
                error: true,
                msg: "Nieprawidłowy format"
            };
    };

    const phoneOptional = (value) => {


        if(lang === 'en-US') {
            if ( !value || value === "+48 " ) {
                return { error: false };
            }

            return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(value) ? {error: false} : {
                error: true,
                msg: "E-mail address is invalid"
            };
        }


        if(lang === 'pl-PL') {
            if ( !value || value === "+48 " ) {
                return { error: false };
            }

            return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(value) ? {error: false} : {
                error: true,
                msg: "Podany numer telefonu jest nieprawidłowy"
            };
        }
    };

    return {
        init: init,
        returnValidationRule: returnValidationRule
    };
})();

export {validationRules}
